import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';

export interface RowProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  /**
   * CSS grid-template-columns value (e.g. `'minmax(0,1fr) 80px auto'`).
   * Sets the row's column layout via inline `style`.
   */
  template: string;
  /** Tints the row with the overdue-red wash. */
  overdue?: boolean;
  children: ReactNode;
}

/**
 * Generic data row — grid layout with hairline bottom border, hover wash,
 * 36px min-height (`--row-h`). Matches dashboard.html `.row`.
 */
export function Row({
  template,
  overdue,
  children,
  className,
  style,
  ...rest
}: RowProps) {
  const cls = ['pn-row', overdue ? 'pn-row-overdue' : '', className]
    .filter(Boolean)
    .join(' ');
  const mergedStyle: CSSProperties = {
    gridTemplateColumns: template,
    ...style
  };
  return (
    <div className={cls} style={mergedStyle} {...rest}>
      {children}
    </div>
  );
}
